module.exports = __webpack_public_path__ + "img/1D-CZ__qGbHTlotm3ytebh1eCGer9pddw.dd779208.png";